import { Check } from "lucide-react";

/**
 * The five-stage progress bar from the prototype.
 *
 * Stage names come from the workflow, not from the implementation: an engineer reads
 * "Drawing Number Resolution", not "resolve_documents".
 */
export const STAGES = [
  { key: "resolve", n: "Stage 1", t: "Input & Tag Identification" },
  { key: "confirm", n: "Stage 2", t: "Master Index Lookup" },
  { key: "parse", n: "Stage 3", t: "Drawing Number Resolution" },
  { key: "extract", n: "Stage 4", t: "Document Dive & Extraction" },
  { key: "review", n: "Stage 5", t: "Extraction Summary" },
] as const;

const ORDER = STAGES.map((s) => s.key) as readonly string[];

export function Stages({ stage, failed }: { stage: string; failed?: boolean }) {
  // "done" collapses to the final stage; anything unrecognised sits at the start.
  const idx = stage === "done" ? STAGES.length - 1 : Math.max(0, ORDER.indexOf(stage));
  return (
    <div className="card">
      <div className="stages">
        {STAGES.map((s, i) => {
          const state = failed && i === idx ? "failed" : i < idx ? "done" : i === idx ? "current" : "";
          return (
            <div className={`stage ${state}`} key={s.key}>
              {i > 0 && <div className="connector" />}
              <div className="node">{state === "done" ? <Check size={18} strokeWidth={3} /> : i + 1}</div>
              <div className="n">{s.n}</div>
              <div className="t">{s.t}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function stageLabel(stage: string): string {
  if (stage === "done") return "Extraction Summary";
  if (stage === "not_found") return "Tag Not Located";
  return STAGES.find((s) => s.key === stage)?.t ?? stage;
}
